// 通信ライブラリー初期化モジュール
import axios from 'axios';
import { baseURL } from '@/lib/const';

export default axios.create({ baseURL });
